import { Eye, Volume2, MessagesSquare, Sparkles, ArrowRight } from "lucide-react";
import { Reveal, SectionTag, StatusPill } from "./Reveal";

const CARDS = [
  {
    icon: Eye,
    title: "See",
    text: "Photorealistic character on real-time video.",
    span: "lg:col-span-2",
    path: "/mvp/see",
  },
  {
    icon: Volume2,
    title: "Hear",
    text: "Natural voice and conversational intelligence.",
    span: "",
    path: "/mvp/hear",
  },
  {
    icon: Sparkles,
    title: "Feel",
    text: "Expression, movement and persistent personality.",
    span: "",
    path: "/mvp/interact",
  },
  {
    icon: MessagesSquare,
    title: "Engage",
    text: "Measurable one-to-one interaction.",
    span: "lg:col-span-2",
    path: "/mvp/talk",
  },
];

const CHIPS = ["AI avatar", "Live video", "Voice", "Conversation", "Expressions", "Emotions", "Movement"];

export default function Mvp() {
  return (
    <section id="mvp" data-testid="mvp-section" className="relative bg-[#0a0a0a] py-16 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <SectionTag>The MVP</SectionTag>
            <h2 className="font-display mt-5 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
              Our MVP
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <StatusPill data-testid="mvp-status-pill" tone="amber">Currently in development</StatusPill>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#C5CBD5]">
            The first product milestone is a working real-time AI videochat experience with
            photorealistic AI characters. The intended experience is simple and immediate.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {CARDS.map(({ icon: Icon, title, text, span, path }, i) => (
            <Reveal key={title} delay={0.08 * i} className={span}>
              <a
                href={path}
                data-testid={`mvp-card-${title.toLowerCase()}`}
                className="group block h-full rounded-2xl border border-white/10 bg-black/40 p-8 transition-colors duration-500 hover:border-cyan-300/40"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-full border border-cyan-300/25 bg-cyan-300/10 text-cyan-200 transition-transform duration-500 group-hover:-translate-y-1">
                  <Icon size={18} />
                </div>
                <h3 className="font-display mt-6 text-xl font-medium tracking-tight text-white">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#C5CBD5]">{text}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-cyan-300/90 transition-colors duration-300 group-hover:text-cyan-100">
                  Learn more
                  <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {CHIPS.map((c) => (
              <span key={c} className="rounded-full border border-white/10 px-4 py-1.5 text-[11px] uppercase tracking-[0.2em] text-white/70">
                {c}
              </span>
            ))}
          </div>
          <p className="mt-8 text-xs leading-relaxed text-white/55">
            The MVP is currently in development. The commercial product has not yet launched.
          </p>
          <a
            href="/register"
            data-testid="mvp-register-cta"
            className="group mt-6 inline-flex items-center gap-2 rounded-md border border-cyan-300/30 px-6 py-3 text-sm font-semibold text-cyan-200/90 transition-all duration-300 hover:-translate-y-0.5 hover:border-cyan-300/60 hover:text-cyan-100"
          >
            Register for Early Access
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
